"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { parseManagedFeaturesList } from "../../lib/function"
import { FaArrowRight } from "react-icons/fa"; // FontAwesome Icon
import { Button } from "react-bootstrap";

type ServerPackage = {
  id: string;
  name: string;
  price: string;
  oldPrice: string;
  discount: string;
  term: string;
  features: string[];
  configureUrl: string;
};

type DurationPlan = {
  type: string;
  currency: string;
  period: number;
  price: number;
  actuall_price: number;
  desc: string;
  discount: number;
};

type DurationMap = {
  [key: string]: DurationPlan;
};

const PricingTable: React.FC = () => {
  const [packages, setPackages] = useState<ServerPackage[]>([]);
  const pathname = usePathname();
  const rawSlug = pathname?.split("/").pop() || "";

  const pageTitle = rawSlug
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch('/api/plan', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            rawSlug
          }),
        });
        const response = await res.json(); 
        const mappedPackages: ServerPackage[] = response.data.slice(0, 20).map((item: { id: number, name: string, description:string, duration: DurationMap }) => ({
          id: item.id.toString(),
          name: item.name,
          price: `$${item.duration.monthly.price || 0.00}`,
          oldPrice: `$${item.duration.monthly.actuall_price.toFixed(2)}`,
          discount: item.duration.monthly.discount > 0 ? `Save ${item.duration.monthly.discount}%` : "0",
          term: `Price per ${item.duration.monthly.desc}`,
          features: parseManagedFeaturesList(item.description, rawSlug),
          configureUrl: `${process.env.NEXT_PUBLIC_API_BASE_URL}/cart.php?a=add&pid=${item.id}&billingcycle=${item.duration.monthly.type}`
        }));
        setPackages(mappedPackages);
      } catch (err) {
        console.error("Failed to fetch packages", err);
      }
    };

    fetchData();
  }, [rawSlug]);

  return (
    <div className="container mt-4">
      <div className="text-center custSpace ">
        <h1 className="display-5 fw-bold textHad">
          <span className="text-capitalize">{pageTitle}</span> 
        </h1>
        <p className="fs-4 fw-normal textPara">
        Expert Support, Flexible, Financially Wise. We help you migrate and optimize your IT<br/>infrastructure to one of the best service providers in the world.
        </p>
      </div>

      {/* Render Packages */}
      <div className="row d-flex justify-content-center">
        {packages.map((pkg) => (
          <div key={pkg.id} className="col-lg-3 col-md-6 col-12 mb-4">
            <div className="card-body h-100">
              {/* <h3 className="card-title fw-bold mb-2">
                <span className="fw-semibold fs-5 textOrange">{pkg.name}</span>
              </h3> */}
                         <h3 className="card-title fw-bold fs-5">
                  <span className="textOrange">{pkg.name}</span>
                </h3>

              <p className="text-muted">{pkg.term}</p>
              <div className="d-flex align-items-end mb-2">
                <span className="display-6 fw-bolder">{pkg.price}</span>
                <span className="text-muted ms-1">/mo</span>
              </div>
              {pkg.discount !== "0" && (
                <h4 className="text-muted fw-normal my-2">
                  <del className="text-muted fs-5 fw-bold">{pkg.oldPrice}</del>
                  <span className="textPara alert alert-warning py-1 px-2 fw-semibold ms-2 fntSize">
                    {pkg.discount}
                  </span>
                </h4>
              )}  
              <Link href={pkg.configureUrl}> 
                  <Button className="orangeBtn fw-semibold w-100"  size="lg">
                ORDER <FaArrowRight className="" />
                </Button> 
                </Link>

              <h4 className="fs-5 fw-bold">Features</h4>
              <ul className="list-unstyled custList">
                {pkg.features.map((feature, index) => (
                  <li key={index}>
                    <span className="text-success">✔</span>{" "}
                    <span className="textHad fw-semibold">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingTable;
